import { z } from 'zod';

import { KnowledgeArticleSummarySchema } from './article';
import { KnowledgeFolderNodeSchema } from './folder';

// The whole browse surface in one payload: every folder (with its derived path) and
// every article summary. The admin UI composes the tree from `parentId` links and
// groups articles by `folderId`.
export const KnowledgeTreeSchema = z.object({
  folders: z.array(KnowledgeFolderNodeSchema),
  articles: z.array(KnowledgeArticleSummarySchema),
});
export type KnowledgeTree = z.infer<typeof KnowledgeTreeSchema>;
